import { AxesDirective, AxisDirective, CircularGaugeComponent, PointerDirective, PointersDirective, RangeDirective, RangesDirective } from '@syncfusion/ej2-react-circulargauge';
import '../App.css';

function GaugeChartComponent() {
  const onAxisLabelRender = (args) => {
    const value = parseInt(args.text);
    if (value % 20 !== 0) {
      args.text = ""; // ✅ Hide labels not divisible by 20
    }
  };
  return (
    <div className="App">
      <CircularGaugeComponent axisLabelRender={onAxisLabelRender}>
        <AxesDirective>
          <AxisDirective startAngle={240} endAngle={120} radius='150'
            labelStyle={{ position: 'Inside' }}
            minimum={0}
            maximum={100}
            majorTicks={{
              interval: 10,
              height: 12,
              position: "Inside",
              color: "#000"
            }}
            minorTicks={{
              interval: 2.5,
              height: 6,
              position: "Inside",
              color: "#888"
            }}
            needleTail={{ length: "0%" }}
          >
            <PointersDirective>
              <PointerDirective value={82.67}
                // cap = {{radius: 15}} color='#61dafb'>
                cap={{ radius: 10, color: "black", border: { width: 0 } }} color='#61dafb'>
              </PointerDirective>
            </PointersDirective>
            <RangesDirective >
              <RangeDirective start={0} end={30} color='#efa7e7' position='Outside'></RangeDirective>
              <RangeDirective start={30} end={70} color='#4a1f65' position='Outside'></RangeDirective>
              <RangeDirective start={70} end={100} color='#324372' position='Outside'></RangeDirective>
            </RangesDirective>
          </AxisDirective>
        </AxesDirective>
      </CircularGaugeComponent>
    </div>
  );
}

export default GaugeChartComponent;